export default __webpack_public_path__ + "static/media/create-club-empty-state.ebf4a74e.png";